import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=d9d19622&scoped=true"
import script from "./Announcement.vue?vue&type=script&lang=js"
export * from "./Announcement.vue?vue&type=script&lang=js"
import style0 from "./Announcement.vue?vue&type=style&index=0&id=d9d19622&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d19622",
  null
  
)

export default component.exports